import React from 'react'
import { styled } from 'linaria/react'
import { NavArrowLeft, NavArrowRight } from 'iconoir-react'
import { theme } from '../../Theme'
import GoToPage from './GoToPage'

const PaginationContent = styled.ul`
   margin-bottom: 0px;
   display: flex;
   list-style: none;
   align-items: center;
   .pagination-item {
      list-style: none;
      > button {
         font-family: var(--font-industry) !important;
         font-size: 1.125rem !important;
         background-color: transparent !important;
         padding: 0 6px;
         ${theme.above.xl} {
            font-size: 1.25rem !important;
            padding: 0 8px;
         }
      }
      button:hover {
         opacity: 0.6;
      }
      button:hover:disabled {
         opacity: 1;
      }
   }
`
function PaginationItem({ isDisabled, onClick, ...props }) {
   return (
      <li className="pagination-item">
         <button
            disabled={isDisabled}
            onClick={event => {
               if (isDisabled) {
                  return
               }
               event.preventDefault()
               onClick(event)
            }}
            {...props}
         />
      </li>
   )
}

export default function Pagination({ metaData, updateFilters }) {
   const { totalCount, currentPage, pageSize, totalPages } = metaData ?? {}
   const isFirstPage = currentPage === 1
   const isLastPage = currentPage === totalPages

   const handlePageChange = newPage => {
      updateFilters?.([
         {
            fieldName: 'page',
            value: newPage,
         },
      ])
   }

   // const visibleHits = isLastPage
   //    ? totalCount
   //    : Math.min(currentPage * pageSize, totalCount)

   const jumpToNextSection = () => {
      const nextPage = Math.min(currentPage + 3, totalPages)
      handlePageChange(nextPage)
   }

   const jumpToPreviousSection = () => {
      const previousPage = Math.max(currentPage - 3, 1)
      handlePageChange(previousPage)
   }

   return (
      <>
         {totalPages > 0 && (
            <div
               className="d-flex flex-column align-items-center"
               style={{ rowGap: '0.5rem' }}
            >
               {/* <div>
                  Visar {visibleHits} av {totalCount} produkter
               </div> */}
               <PaginationContent>
                  <PaginationItem
                     id="previous-page"
                     aria-label="Previous page"
                     isDisabled={isFirstPage}
                     onClick={() => handlePageChange(currentPage - 1)}
                  >
                     <NavArrowLeft />
                  </PaginationItem>

                  {currentPage > 3 && (
                     <PaginationItem
                        id="first-page"
                        aria-label={`Page 1`}
                        onClick={() => handlePageChange(1)}
                     >
                        1
                     </PaginationItem>
                  )}

                  {currentPage > 4 && (
                     <PaginationItem
                        aria-label="Jump to previous pages"
                        onClick={jumpToPreviousSection}
                     >
                        ...
                     </PaginationItem>
                  )}

                  {[...Array(totalPages ?? 0)].map((_, index) => {
                     const page = index + 1
                     const delta = 2
                     // Only show pages within the range of [currentPage - 2, currentPage + 2]
                     if (
                        page >= currentPage - delta &&
                        page <= currentPage + delta
                     ) {
                        return (
                           <PaginationItem
                              key={page}
                              isDisabled={page === currentPage}
                              aria-label={`Page ${page}`}
                              onClick={() => handlePageChange(page)}
                           >
                              {page}
                           </PaginationItem>
                        )
                     }

                     return null
                  })}

                  {currentPage < totalPages - 3 && (
                     <PaginationItem
                        aria-label="Jump to next pages"
                        onClick={jumpToNextSection}
                     >
                        ...
                     </PaginationItem>
                  )}

                  {currentPage < totalPages - 2 && (
                     <PaginationItem
                        id="last-page"
                        aria-label={`Page ${totalPages}`}
                        onClick={() => handlePageChange(totalPages)}
                     >
                        {totalPages}
                     </PaginationItem>
                  )}

                  <PaginationItem
                     aria-label="Next page"
                     id="next-page"
                     isDisabled={isLastPage}
                     onClick={() => handlePageChange(currentPage + 1)}
                  >
                     <NavArrowRight />
                  </PaginationItem>
               </PaginationContent>
               {totalPages > 1 && (
                  <GoToPage
                     totalPages={totalPages}
                     handlePageChange={handlePageChange}
                     scrollToTopElement
                  />
               )}
            </div>
         )}
      </>
   )
}
